import React, { Suspense, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useHistory } from "react-router-dom";
import Abutton from "../../components/atoms/Abutton";
import NavDetail from "../../components/navbar/NavDetail";
import OdisputeBnibTransaction from "../../components/organisms/bnib_transaction/OdisputeBnibTransaction";

const OconfirmArriveBnibTransaction = React.lazy(
  () =>
    import(
      "../../components/organisms/bnib_transaction/OconfirmArriveBnibTransaction"
    )
);

const ScanStockMove = () => {
  const history = useHistory();
  const [openDialog, setOpenDialog] = useState({
    location_dest_name: "",
    status: false,
  });

  const handleOpenDialog = (result: string) => {
    setOpenDialog({
      location_dest_name: result,
      status: true,
    });
  };

  const handleScan = (result: any, error: any) => {
    if (!!result) {
      handleOpenDialog(result);
    }
  };

  const handleClosed = () => {
    setOpenDialog({
      location_dest_name: "",
      status: false,
    });
  };

  const handleBack = () => {
    history.goBack();
  };

  return (
    <>
      <Suspense fallback={<></>}>
        <OconfirmArriveBnibTransaction
          isOpen={openDialog.status}
          handleClosed={handleClosed}
          location_dest_name={openDialog.location_dest_name}
          handleBack={handleBack}
        />
      </Suspense>
      {/* <OdisputeBnibTransaction
        handleNext={handleNext}
        isOpen={openDisputeDialog}
        setOpen={setOpenDisputeDialog}
      /> */}
      <div className="fixed top-0 z-30">
        <NavDetail
          title1="Scan"
          title2="Stock Arrive"
          handleBack={handleBack}
        />
      </div>
      <div className="flex flex-col h-screen max-h-screen items-center justify-center sm:pt-24 pt-16">
        <div className="flex justify-end w-full">
          <Abutton title="Skip Scan QR" onClick={() => handleOpenDialog("")} />
        </div>
        <div className="xl:w-1/2 lg:w-10/12 w-full h-full xl:-mt-28 sm:-mt-14 -mt-8">
          <QrReader
            scanDelay={300}
            onResult={handleScan}
            constraints={{ facingMode: "user" }}
          />
        </div>
      </div>
    </>
  );
};

export default ScanStockMove;
